export const HOME = "/";
export const LOGIN = "/log-in";
export const LOGOUT = "/log-out";
export const ACCOUNT = "/account";
export const DASHBOARD = `${ACCOUNT}/dashboard`;
export const MY_PROFILE = `${ACCOUNT}/profile`;
export const UPDATE_PASSWORD = `${ACCOUNT}/update-password`;
export const FORGOT_PASSWORD = `${ACCOUNT}/forgot-password`;
export const RESET_PASSWORD = `${ACCOUNT}/reset-password/:token/:uuid`;
export const RESET_PASSWORD_CONFIRM = `${ACCOUNT}/reset-password-confirmation`;
export const PAGE404 = "/404";
export const PAGE401 = "/401";
export const LOCKSCREEN = "/lock-screen";
export const SECURITY = "/security";
export const USERS = `${SECURITY}/users/list`;
export const USERS_CREATE = `${USERS}/create`;
export const USERS_MODIFY = `${USERS}/:uuid/modify`;
export const USER_DETAIL = `${USERS}/:uuid/detail`;
export const CLIENTS = `${SECURITY}/clients/list`;
export const CLIENTS_CREATE = `${CLIENTS}/create`;
export const CLIENTS_MODIFY = `${CLIENTS}/:uuid/modify`;
export const CLIENTS_DETAIL = `${CLIENTS}/:uuid/detail`;
export const MODULES = "/modules";

// PARTNER
export const PARTNER = `${MODULES}/partner/list`;
export const PARTNER_MODIFY = `${PARTNER}/:uuid/modify`;
export const PARTNER_CREATE = `${PARTNER}/create`;
export const PARTNER_DETAIL = `${PARTNER}/:uuid/detail`;

// FAQ
export const FAQ = `${MODULES}/faq/list`;
export const FAQ_MODIFY = `${FAQ}/:uuid/modify`;
export const FAQ_CREATE = `${FAQ}/create`;
export const FAQ_DETAIL = `${FAQ}/:uuid/detail`;

// NEWS
export const NEWS = `${MODULES}/news/list`;
export const NEWS_MODIFY = `${NEWS}/:uuid/modify`;
export const NEWS_CREATE = `${NEWS}/create`;
export const NEWS_DETAIL = `${NEWS}/:uuid/detail`;

// WEBINARS
export const WEBINAR = `${MODULES}/webinar/list`;
export const WEBINAR_MODIFY = `${WEBINAR}/:uuid/modify`;
export const WEBINAR_CREATE = `${WEBINAR}/create`;
export const WEBINAR_DETAIL = `${WEBINAR}/:uuid/detail`;

// ARTISTS
export const ARTIST = `${MODULES}/artist/list`;
export const ARTIST_DETAIL = `${ARTIST}/:uuid/detail`;

// AWARDS
export const AWARD = `${MODULES}/award/list`;
export const AWARD_MODIFY = `${AWARD}/:uuid/modify`;
export const AWARD_CREATE = `${AWARD}/create`;
export const AWARD_DETAIL = `${AWARD}/:uuid/detail`;
export const AWARD_VIDEO = `${AWARD}/video/update`;

// PROJECTS
export const PROJECT = `${MODULES}/project/list`;
export const PROJECT_DETAIL = `${PROJECT}/:uuid/detail`;

// MEDIA
export const MEDIA = `${MODULES}/media/list`;
export const MEDIA_MODIFY = `${MEDIA}/:uuid/modify`;
export const MEDIA_CREATE = `${MEDIA}/create`;
export const MEDIA_DETAIL = `${MEDIA}/:uuid/detail`;
